import React, { useCallback, useState, useRef, useEffect } from 'react';
import { Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../dynamicFormBuilder/FormField';
import { GridLayout } from "../../../common/GridLayout";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
} from "devextreme-react/data-grid";
import { buildDxFilters, FillFilters } from '../../../common/Utils';
import { SearchLayout } from './Layout';
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";
import axios from 'axios';
import data from '../../../assets/apiRoutes.json';
import { Module } from 'module';
import { OM } from '../../../const/constants';
import { RecordTypes } from '../../../enum/Enum';

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];

const List = (props) => {
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(false);
    const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
    const rowId = useRef(null);
    const dataGrid = useRef(null);
    const [resultData, setResultData] = useState(null);

    const allowedPageSizes = [10, 20, 100, 500, 1000];
    const gridKey = "2FBD6B9A-5A13-4B62-9D7B-2BAB5C0FA2B9";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => {
        return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout);
    }, [currentLayout, accessToken]);

    const saveState = useCallback((state) => {
        GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout);
    }, [gridKey, currentLayout, accessToken]);

    const initialFormFields = {
        Code: null,
        CodeType: null,
        Description1: '',
        Description2: '',
        RecordType: RecordTypes.Receipt,
        Module: OM,
        Comment: null,
        PopupMessage: ''
    };
    const [formFields, setformFields] = useState(initialFormFields);

    const onSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData && selectedRowsData.length == 1) {
            rowId.current = selectedRowsData[0].RowId;
        }
        else {
            rowId.current = '';
        }
        setIsEditButtonDisabled(!isEditButtonDisabled);
    };

    const handelEditClick = () => {
        const buttonUrl = "/om/codes/descriptive-codes-data-entry-edit?id=" + rowId.current;
        history.push(buttonUrl);
    };

    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );

    const handleSearch = (e) => {
        e.event.stopPropagation();
        let datasource = loadDatasource();
        const filters = FillFilters(formFields);
        datasource.filter(filters);
        setResultData(datasource);
    };

    const handleReset = (e) => {
        e.event.stopPropagation();
        setformFields(initialFormFields);
        setResultData(loadDatasource());
    };

    useEffect(() => {
        setResultData(loadDatasource());
    }, []);

    const handleFormLoad = useCallback(() => {
        // Load any static data or lookups if needed
    }, []);

    const handleFieldChange = useCallback((name, value) => {
        // Handle field changes if needed
    }, []);

    const loadDatasource = () => {
        let store = createStore({
            key: 'RowId',
            loadParams: formFields,
            loadUrl: `${window._env_.REACT_APP_APIS}/${data.OM?.GetCodes || 'om/Codes/GetCodes'}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        const dataSource = new DataSource({ store: store });
        return dataSource;
    };

    return (
        <div className="search-page-container">
            <div className="search-page-content">
                <div id="accordion" className="search-page-accordion">
                    <AccordionReact
                        dataSource={searchpanel}
                        collapsible={true}
                        multiple={false}
                        animationDuration={300}
                        selectedItems={selectedItems}
                        onSelectionChanged={e => {
                            if (e.currentTarget === e.target) {
                                selectionChanged(e, e.target);
                            }
                        }}
                        itemTitleRender={() => (
                            <Toolbar className="accordian-toolbar">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2
                                            }}
                                        >
                                            Enter Your Query For OM Descriptive Codes
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                            </Toolbar>
                        )}
                        itemRender={(itemProps) => (
                            <FormField
                                currrentUser={currentUser}
                                layoutId='AB8EF442-7CC4-4B9E-BF2F-EECAA2AB9E8A'
                                layoutName='OMDescriptiveCodesSearchForm'
                                defaultFormSchema={SearchLayout}
                                formFields={formFields}
                                setformFields={setformFields}
                                handleFieldValueChange={handleFieldChange}
                                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                formRefs={formRefs}
                                onFormLoad={handleFormLoad}
                                noSpacingBeforeFirstRow={true}
                            />
                        )}
                        id="accordion-container" className="accordion-height"
                    />
                </div>
                <div className="search-page-grid-container">
                    <DataGrid
                        onExporting={(e) => {
                            if (window.handleDevExtremeDataGridExport) {
                                window.handleDevExtremeDataGridExport(e);
                            }
                        }}
                        ref={dataGrid}
                        allowColumnReordering={true}
                        allowColumnResizing={true}
                        dataSource={resultData}
                        showBorders={true}
                        hoverStateEnabled={true}
                        className={selectedItems.length > 0 ? "GridHeightAccordianOpen" : "GridHeightAccordianClose"}
                        onSelectionChanged={(e) => onSelectionChanged(e)}
                        remoteOperations={true}
                        searchEnabled={true}
                        columnAutoWidth={true}
                    >
                        <ColumnChooser
                            enabled={true}
                            title="Choose Column"
                            width={290}
                            height={290}
                            sortOrder="asc"
                        >
                            <ColumnChooserSearch
                                enabled={true}
                                editorOptions={{ placeholder: 'Search column' }} />
                        </ColumnChooser>
                        <Export enabled={true} allowExportSelectedData={true} />
                        <Selection mode="multiple" />
                        <Sorting visible={true} mode="multiple" />
                        <Paging defaultPageSize={10} />
                        <Pager
                            visible={true}
                            showPageSizeSelector={true}
                            allowedPageSizes={allowedPageSizes}
                            showNavigationButtons={true}
                        />
                        <FilterRow visible={true} />
                        <FilterPanel visible={true} />
                        <GroupPanel visible={true} />
                        <Grouping autoExpandAll={false} />
                        <StateStoring
                            enabled={true}
                            type="custom"
                            customLoad={loadState}
                            storageKey={gridKey}
                            customSave={saveState}
                        />
                        <Column dataType="string" dataField="CodeType" caption="Code Type" />
                        <Column dataType="string" dataField="Code" caption="Code" />
                        <Column dataType="string" dataField="Description1" caption="Description 1" />
                        <Column dataType="string" dataField="Description2" caption="Description 2" />
                        <Column dataType="string" dataField="Comment" caption="Comment" allowSorting={false} />
                        <Column dataType="datetime" dataField="CreationDateTime" caption="Creation Date Time" />
                        <Column dataType="string" dataField="CreationUserId" caption="Creation User" />
                        <Column dataType="datetime" dataField="LastUpdateDateTime" caption="Last Update Date Time" />
                        <Column dataType="string" dataField="LastUpdateUserId" caption="Last Update User" />

                        <GridToolbar>
                            <GridToolbarItem location="before">
                                <Button
                                    disabled={isEditButtonDisabled}
                                    onClick={handelEditClick}
                                    type="default"
                                    text="Edit"
                                ></Button>
                            </GridToolbarItem>
                            <GridToolbarItem location="before">
                                <Link to="/om/codes/descriptive-codes-data-entry-create">
                                    <Button
                                        type="default"
                                        text="Create"
                                        className="gridTopButton"
                                    ></Button>
                                </Link>
                            </GridToolbarItem>
                            <GridToolbarItem location="after">
                                <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                            </GridToolbarItem>
                            <GridToolbarItem name="exportButton" />
                            <GridToolbarItem name="columnChooserButton" />
                        </GridToolbar>
                    </DataGrid>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(List);
